import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgRedux } from '@angular-redux3/store';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { PlaylistRemoteAppState, ACreatePlaylist } from '../../store';
import { Playlist } from '../../store/entities';
import { PlaylistPickerComponent } from '../playlist-picker/playlist-picker.component';

@Injectable({
  providedIn: 'root'
})
export class LibraryService {
  constructor(
    private dialog: MatDialog,
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
  ) {}

  private playerId = '';

  getLastPlayerId(): string {
    return this.playerId;
  }

  setLastPlayerId(playerId: string): void {
    this.playerId = playerId;
  }

  openPlaylistPicker(isNew: boolean): Observable<Partial<Playlist>> {
    const config = new MatDialogConfig();
    config.data = { isNew };
    return this.dialog.open(PlaylistPickerComponent, config).afterClosed().pipe(
      filter(Boolean),
      tap((playlist: Playlist) => isNew && this.ngRedux.dispatch(ACreatePlaylist(playlist)))
    );
  }
}
